// TODO: keep your URLs defined centrally here
export const LINKS = {
    CertifID: {
        PrivacyPolicy: 'https://www.certifid.com/company/privacy-policy',
        TermsOfUse: 'https://www.certifid.com/company/terms-of-service',
        VerifyIdentityMoreInfo: 'https://certifidhelpcenter.zendesk.com/hc/en-us/articles/18426417319579-I-don-t-feel-comfortable-providing-my-personal-information',
        RoutingNumberHelp: 'https://certifidhelpcenter.zendesk.com/hc/en-us/articles/18426877980315-Where-do-I-find-my-routing-number-',
        CameraPermissionsHelp: 'https://certifidhelpcenter.zendesk.com/hc/en-us/articles/51442696491291-Updating-Device-Camera-Permissions-Settings-for-ID-Verification',
    },
    Mpp: {
        LearnMore: 'https://certifid.com/money-protection-plan/',
    },
};